import React, { useState } from 'react';
import { Modal } from '../../components/ui';
import { errMsg } from '../../utils/format';
import { useFetch } from '../../hooks/useFetch';
import api from '../../utils/api';

export default function AddRawMaterialModal({ onClose, onSaved }) {
  const { data: vendors } = useFetch('/api/vendors');
  const { data: categories } = useFetch('/api/raw-materials/categories');
  const [form, setForm] = useState({ name:'', unitOfMeasure:'Each', category:'', quantityOnHand:'0', unitCost:'0', minStockLevel:'0', criticalStockLevel:'0', preferredVendorId:'', notes:'' });
  const [saving, setSaving] = useState(false);

  const save = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      await api.post('/api/raw-materials', { ...form, preferredVendorId: form.preferredVendorId || null });
      onSaved('Material added successfully'); onClose();
    } catch(err) { alert(errMsg(err)); }
    finally { setSaving(false); }
  };

  const set = (k,v) => setForm(f => ({...f, [k]:v}));

  return (
    <Modal title="Add Raw Material" onClose={onClose}
      footer={<><button className="btn" onClick={onClose}>Cancel</button><button className="btn btn-primary" form="add-mat-form" type="submit">{saving?'Saving…':'Add material'}</button></>}>
      <form id="add-mat-form" onSubmit={save}>
        <div className="form-row">
          <div className="form-group"><label>Material name *</label><input required value={form.name} onChange={e=>set('name',e.target.value)} /></div>
          <div className="form-group"><label>Unit of measure *</label><input required value={form.unitOfMeasure} onChange={e=>set('unitOfMeasure',e.target.value)} placeholder="e.g. kg, m, units" /></div>
        </div>
        <div className="form-group">
          <label>Category</label>
          <input list="rm-categories" value={form.category} onChange={e=>set('category',e.target.value)} placeholder="e.g. Hardware, Electronics, Mounts" />
          <datalist id="rm-categories">
            {(categories||[]).map(c => <option key={c} value={c} />)}
          </datalist>
        </div>
        <div className="form-row">
          <div className="form-group"><label>Quantity on hand</label><input type="number" step="0.0001" min="0" value={form.quantityOnHand} onChange={e=>set('quantityOnHand',e.target.value)} /></div>
          <div className="form-group"><label>Unit cost ($)</label><input type="number" step="0.0001" min="0" value={form.unitCost} onChange={e=>set('unitCost',e.target.value)} /></div>
        </div>
        <div className="form-row">
          <div className="form-group"><label>Minimum stock level</label><input type="number" step="0.0001" min="0" value={form.minStockLevel} onChange={e=>set('minStockLevel',e.target.value)} /></div>
          <div className="form-group"><label>Critical stock level</label><input type="number" step="0.0001" min="0" value={form.criticalStockLevel} onChange={e=>set('criticalStockLevel',e.target.value)} /></div>
        </div>
        <div className="form-group"><label>Preferred vendor</label>
          <select value={form.preferredVendorId} onChange={e=>set('preferredVendorId',e.target.value)}>
            <option value="">— None —</option>
            {(vendors||[]).map(v=><option key={v.id} value={v.id}>{v.name}</option>)}
          </select>
        </div>
        <div className="form-group"><label>Notes</label><textarea value={form.notes} onChange={e=>set('notes',e.target.value)} /></div>
      </form>
    </Modal>
  );
}
